import React, {useState} from "react";

import Layout from "./layout";
import {
  ProgressBar,
  Card,
  Row,
  Col,
  Button,
  Form,
  Alert,
  Modal
} from "react-bootstrap";
import { Dropdown, Nav } from "react-bootstrap";

const ProfileDetails: React.FC = () => {
  const progressValue = 80; // Adjust progress value here
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <Layout>
         <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Add Review</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="review_radioctrl">
                            <p className="post_review">Post Review as Anonymous</p>
                            <div className="d-flex align-items-center justify-content-center gap-20">
                                <div className="custom-control custom-radio custom-radio-outline custom-radio-primary mb-3 d-flex gap-15">
                                    <input type="radio" id="customRadiooutlinecolor1" name="customRadiooutlinecolor1" className="custom-control-input" />
                                    <label className="custom-control-label" htmlFor="customRadiooutlinecolor1">Yes</label>
                                </div>
                                <div className="custom-control custom-radio custom-radio-outline custom-radio-primary mb-3 d-flex gap-15">
                                    <input type="radio" id="customRadiooutlinecolor2" name="customRadiooutlinecolor1" className="custom-control-input" checked />
                                    <label className="custom-control-label" htmlFor="customRadiooutlinecolor2">No</label>
                                </div>
                            </div>

                        </div>
                        <div className="rating_redbg">
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="">Rating</label>
                                        <select id="formrow-inputState" className="form-control">
                                            <option>Conventional</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="">Loan Type</label>
                                        <select id="formrow-inputState" className="form-control">
                                            <option>Purchase</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="rating_whitebg">
                            <div className="row">
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="">Date</label>
                                        <input type="date" className="form-control"/>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="">FICO Score</label>
                                        <input type="text" className="form-control"/>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="">CTC</label>
                                        <input type="text" className="form-control"/>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="">Heading</label>
                                        <input type="text" className="form-control"/>
                                    </div>
                                </div>
                                <div className="col-lg-12 col-md-12">
                                    <div className="form-group">
                                        <label htmlFor="">Comment</label>
                                        <textarea  className="form-control min_h120"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <p className="post_review d-flex justify-content-center">Rate your experience</p>
                        <div className="d-flex justify-content-center mb-3">
                            <a href="#">
                                <img src="assets/images/review/star.png"/>
                            </a>
                        </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-outline-danger w-md btn-lg px-5"  onClick={handleClose}>
            Close
          </Button>
          <Button className="btn btn-primary w-md btn-lg px-5"  onClick={handleClose}>
            Submit
          </Button>
        </Modal.Footer>
      </Modal>
      <div data-aos="fade-up" data-aos-duration="1000">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-flex align-items-center justify-content-between">
              <div className="d-flex align-items-center gap-15">
                <h1 className="mb-0 text-xxl">
                  Profile <span className="text-accent">Details</span>
                </h1>
                <div className="btn-group">
                  <button
                    type="button"
                    className="btn btn-primary dropdown-toggle rate_checker"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Rate Calculator <i className="mdi mdi-chevron-down"></i>
                  </button>
                  <div className="dropdown-menu">
                    <a className="dropdown-item" href="#">
                      Rate Calculator
                    </a>
                    <div className="dropdown-item multidropdown">
                      Lender Price Rate Calculator
                      <ul>
                        <li>
                          <a href="#">275 BPS</a>
                        </li>
                        <li>
                          <a href="#">200 BPS</a>
                        </li>
                        <li>
                          <a href="#">0 BPS</a>
                        </li>
                        <li>
                          <a href="#">Account</a>
                        </li>
                        <li>
                          <a href="#">
                            Powered by <strong>Lender Price</strong>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="page-title-right">
                <ol className="breadcrumb m-0">
                  <li className="breadcrumb-item">
                    <a href="javascript: void(0);">Home</a>
                  </li>
                  <li className="breadcrumb-item active">Profile Details</li>
                </ol>
              </div>
            </div>
          </div>
        </div>

        <div className="row mb-4">
          <div className="col-sm-4">
            <div className="details-info-block d-flex">
              <div className="details-info-pic">
                <img src="assets/images/lenda/01.png" />
              </div>
              <div className="details-info-content">
                <div className="d-flex fb-like mb-2">
                  <p className="d-flex align-items-center">
                    <img src="assets/images/icons/facebook-like.svg" />
                    814
                  </p>
                  <p className="d-flex align-items-center">
                    <img src="assets/images/icons/facebook-dislike.svg" />
                    84
                  </p>
                </div>
                <h3>United Wholesale Mortgage</h3>
                <p>Faster Easier Cheaper Mortgages</p>
                <div className="d-flex gap-2 mb-3">
                  <a
                    href="#"
                    className="add-rating-btn"
                    data-toggle="modal"
                    data-target=".bs-example-modal-lg"
                    onClick={handleShow} >
                    Add Rating +
                  </a>
                  <a href="#" className="round-btn">
                    <img src="assets/images/icons/note.svg" />
                  </a>
                  <a href="#" className="round-btn">
                    <img src="assets/images/icons/share.svg" />
                  </a>
                  <a href="#" className="round-btn">
                    <img src="assets/images/icons/copy.svg" />
                  </a>
                </div>
                <p className="d-flex gap-1 align-items-center">
                  <img src="assets/images/icons/website-icon.svg" />{" "}
                  <a href="#">http://www.uwm.com</a>
                </p>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="rating-block">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h3>Rating’s</h3>
                <h5>4.9/5</h5>
              </div>
              <div className="rating-row d-flex align-items-center">
                <div className="d-flex gap-1">
                  <span className="rating-no">5</span>
                  <img src="assets/images/icons/rating-star.svg" />
                </div>
                <div className="rating-line flex-grow-1"></div>
                <span>219</span>
              </div>
              <div className="rating-row d-flex align-items-center">
                <div className="d-flex gap-1">
                  <span className="rating-no">4</span>
                  <img src="assets/images/icons/rating-star.svg" />
                </div>
                <div className="rating-line flex-grow-1"></div>
                <span>1</span>
              </div>
              <div className="rating-row d-flex align-items-center">
                <div className="d-flex gap-1">
                  <span className="rating-no">3</span>
                  <img src="assets/images/icons/rating-star.svg" />
                </div>
                <div className="rating-line flex-grow-1"></div>
                <span>5</span>
              </div>
              <div className="rating-row d-flex align-items-center">
                <div className="d-flex gap-1">
                  <span className="rating-no">2</span>
                  <img src="assets/images/icons/rating-star.svg" />
                </div>
                <div className="rating-line flex-grow-1"></div>
                <span>8</span>
              </div>
              <div className="rating-row d-flex align-items-center">
                <div className="d-flex gap-1">
                  <span className="rating-no">1</span>
                  <img src="assets/images/icons/rating-star.svg" />
                </div>
                <div className="rating-line flex-grow-1"></div>
                <span>6</span>
              </div>
            </div>
          </div>
          <div className="col-sm-4">
            <div className="details-brief-block">
              <div className="details-brief-row d-flex justify-content-between align-items-center">
                <p>Average CTC :</p>
                <p>12.97 day(s)</p>
              </div>
              <div className="details-brief-row d-flex justify-content-between align-items-center">
                <p>Revenue (BPS) :</p>
                <p>275</p>
              </div>
              <div className="details-brief-row d-flex justify-content-between align-items-center">
                <p>Max & Comp :</p>
                <p>30.000</p>
              </div>
              <div className="details-brief-row d-flex justify-content-between align-items-center">
                <p>VA ID :</p>
                <p>VA Sponsor ID 7460480000</p>
              </div>
              <div className="details-brief-row d-flex justify-content-between align-items-center">
                <p>FHA ID :</p>
                <p>FHA Sponsor ID 7184500000</p>
              </div>
              <div className="details-brief-row d-flex justify-content-between align-items-center">
                <p>Early Pay Off :</p>
                <p>180</p>
              </div>
              <div className="details-brief-row d-flex justify-content-between align-items-center">
                <p>Loan Sifter :</p>
                <img src="assets/images/icons/green-check.svg" />
              </div>
            </div>
          </div>
        </div>

        <div className="processor_bg">
          <div className="processor_search">
            <div className="processor_searcharea">
              <input
                type="text"
                className="form-control"
                placeholder="Search"
              />
              <span className="search_icon">
                <img src="assets/images/processor/search.svg" />
              </span>
            </div>
          </div>
          <div className="processor_listing">
            <ul>
              <li>
                <div className="processor_listtop">
                  <div className="live_btn">
                    <span></span> Live
                  </div>
                  <div className="like_dislike">
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/like.svg" />
                    </a>
                    <span className="like_txt">30</span>
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/dislike.svg" />
                    </a>
                    <span className="dislike_txt">0</span>
                  </div>
                </div>
                <div className="processor_lisbottom">
                  <div className="rocessor_listimgctrl">
                    <div className="rocessor_listimg">
                      <img src="assets/images/processor/image_01.jpg" />
                      <span className="online_circel"></span>
                    </div>
                  </div>
                  <div className="rocessor_listright">
                    <h4>Karen Berryman</h4>
                    <div className="rating">
                      <img src="assets/images/processor/rating.png" /> (4.5/10)
                    </div>
                    <div className="submit_filearea">
                      <a href="javascript:void(0);" className="submit_file">
                        Submit a File
                      </a>
                      <a href="javascript:void(0);" className="favorite_icon">
                        favorite
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div className="processor_listtop">
                  <div className="hour_ago">4 hours ago</div>
                  <div className="like_dislike">
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/like.svg" />
                    </a>
                    <span className="like_txt">30</span>
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/dislike.svg" />
                    </a>
                    <span className="dislike_txt">0</span>
                  </div>
                </div>
                <div className="processor_lisbottom">
                  <div className="rocessor_listimgctrl">
                    <div className="rocessor_listimg">
                      <img src="assets/images/processor/image_02.jpg" />
                      <span className="offline_circel"></span>
                    </div>
                  </div>
                  <div className="rocessor_listright">
                    <h4>Lisa Keller</h4>
                    <div className="rating">
                      <img src="assets/images/processor/rating.png" /> (4.5/10)
                    </div>
                    <div className="submit_filearea">
                      <a href="javascript:void(0);" className="submit_file">
                        Submit a File
                      </a>
                      <a href="javascript:void(0);" className="favorite_icon">
                        favorite
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div className="processor_listtop">
                  <div className="hour_ago">8 hours ago</div>
                  <div className="like_dislike">
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/like.svg" />
                    </a>
                    <span className="like_txt">30</span>
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/dislike.svg" />
                    </a>
                    <span className="dislike_txt">0</span>
                  </div>
                </div>
                <div className="processor_lisbottom">
                  <div className="rocessor_listimgctrl">
                    <div className="rocessor_listimg">
                      <img src="assets/images/processor/image_03.jpg" />
                      <span className="offline_circel"></span>
                    </div>
                  </div>
                  <div className="rocessor_listright">
                    <h4>Megan Thompson</h4>
                    <div className="rating">
                      <img src="assets/images/processor/rating.png" /> (4.5/10)
                    </div>
                    <div className="submit_filearea">
                      <a href="javascript:void(0);" className="submit_file">
                        Submit a File
                      </a>
                      <a href="javascript:void(0);" className="favorite_icon">
                        favorite
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div className="processor_listtop">
                  <div className="hour_ago">6 hours ago</div>
                  <div className="like_dislike">
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/like.svg" />
                    </a>
                    <span className="like_txt">30</span>
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/dislike.svg" />
                    </a>
                    <span className="dislike_txt">0</span>
                  </div>
                </div>
                <div className="processor_lisbottom">
                  <div className="rocessor_listimgctrl">
                    <div className="rocessor_listimg">
                      <img src="assets/images/processor/image_04.jpg" />
                      <span className="offline_circel"></span>
                    </div>
                  </div>
                  <div className="rocessor_listright">
                    <h4>Karen Berryman</h4>
                    <div className="rating">
                      <img src="assets/images/processor/rating.png" /> (4.5/10)
                    </div>
                    <div className="submit_filearea">
                      <a href="javascript:void(0);" className="submit_file">
                        Submit a File
                      </a>
                      <a href="javascript:void(0);" className="favorite_icon">
                        favorite
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div className="processor_listtop">
                  <div className="hour_ago">1 hours ago</div>
                  <div className="like_dislike">
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/like.svg" />
                    </a>
                    <span className="like_txt">30</span>
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/dislike.svg" />
                    </a>
                    <span className="dislike_txt">0</span>
                  </div>
                </div>
                <div className="processor_lisbottom">
                  <div className="rocessor_listimgctrl">
                    <div className="rocessor_listimg">
                      <img src="assets/images/processor/image_05.jpg" />
                      <span className="offline_circel"></span>
                    </div>
                  </div>
                  <div className="rocessor_listright">
                    <h4>Hatice Umur</h4>
                    <div className="rating">
                      <img src="assets/images/processor/rating.png" /> (4.5/10)
                    </div>
                    <div className="submit_filearea">
                      <a href="javascript:void(0);" className="submit_file">
                        Submit a File
                      </a>
                      <a href="javascript:void(0);" className="favorite_icon">
                        favorite
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div className="processor_listtop">
                  <div className="hour_ago">3 hours ago</div>
                  <div className="like_dislike">
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/like.svg" />
                    </a>
                    <span className="like_txt">30</span>
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/dislike.svg" />
                    </a>
                    <span className="dislike_txt">0</span>
                  </div>
                </div>
                <div className="processor_lisbottom">
                  <div className="rocessor_listimgctrl">
                    <div className="rocessor_listimg">
                      <img src="assets/images/processor/image_06.jpg" />
                      <span className="offline_circel"></span>
                    </div>
                  </div>
                  <div className="rocessor_listright">
                    <h4>Jenny Stone</h4>
                    <div className="rating">
                      <img src="assets/images/processor/rating.png" /> (4.5/10)
                    </div>
                    <div className="submit_filearea">
                      <a href="javascript:void(0);" className="submit_file">
                        Submit a File
                      </a>
                      <a href="javascript:void(0);" className="favorite_icon">
                        favorite
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div className="processor_listtop">
                  <div className="hour_ago">4 hours ago</div>
                  <div className="like_dislike">
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/like.svg" />
                    </a>
                    <span className="like_txt">30</span>
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/dislike.svg" />
                    </a>
                    <span className="dislike_txt">0</span>
                  </div>
                </div>
                <div className="processor_lisbottom">
                  <div className="rocessor_listimgctrl">
                    <div className="rocessor_listimg">
                      <img src="assets/images/processor/image_07.jpg" />
                      <span className="offline_circel"></span>
                    </div>
                  </div>
                  <div className="rocessor_listright">
                    <h4>Marie Hooper</h4>
                    <div className="rating">
                      <img src="assets/images/processor/rating.png" /> (4.5/10)
                    </div>
                    <div className="submit_filearea">
                      <a href="javascript:void(0);" className="submit_file">
                        Submit a File
                      </a>
                      <a href="javascript:void(0);" className="favorite_icon">
                        favorite
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div className="processor_listtop">
                  <div className="hour_ago">3 hours ago</div>
                  <div className="like_dislike">
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/like.svg" />
                    </a>
                    <span className="like_txt">30</span>
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/dislike.svg" />
                    </a>
                    <span className="dislike_txt">0</span>
                  </div>
                </div>
                <div className="processor_lisbottom">
                  <div className="rocessor_listimgctrl">
                    <div className="rocessor_listimg">
                      <img src="assets/images/processor/image_08.jpg" />
                      <span className="offline_circel"></span>
                    </div>
                  </div>
                  <div className="rocessor_listright">
                    <h4>Caterina Byrd</h4>
                    <div className="rating">
                      <img src="assets/images/processor/rating.png" /> (4.5/10)
                    </div>
                    <div className="submit_filearea">
                      <a href="javascript:void(0);" className="submit_file">
                        Submit a File
                      </a>
                      <a href="javascript:void(0);" className="favorite_icon">
                        favorite
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div className="processor_listtop">
                  <div className="hour_ago">1 hours ago</div>
                  <div className="like_dislike">
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/like.svg" />
                    </a>
                    <span className="like_txt">30</span>
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/dislike.svg" />
                    </a>
                    <span className="dislike_txt">0</span>
                  </div>
                </div>
                <div className="processor_lisbottom">
                  <div className="rocessor_listimgctrl">
                    <div className="rocessor_listimg">
                      <img src="assets/images/processor/image_09.jpg" />
                      <span className="offline_circel"></span>
                    </div>
                  </div>
                  <div className="rocessor_listright">
                    <h4>Alaxi Sampson</h4>
                    <div className="rating">
                      <img src="assets/images/processor/rating.png" /> (4.5/10)
                    </div>
                    <div className="submit_filearea">
                      <a href="javascript:void(0);" className="submit_file">
                        Submit a File
                      </a>
                      <a href="javascript:void(0);" className="favorite_icon">
                        favorite
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div className="processor_listtop">
                  <div className="hour_ago">4 hours ago</div>
                  <div className="like_dislike">
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/like.svg" />
                    </a>
                    <span className="like_txt">30</span>
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/dislike.svg" />
                    </a>
                    <span className="dislike_txt">0</span>
                  </div>
                </div>
                <div className="processor_lisbottom">
                  <div className="rocessor_listimgctrl">
                    <div className="rocessor_listimg">
                      <img src="assets/images/processor/image_10.jpg" />
                      <span className="offline_circel"></span>
                    </div>
                  </div>
                  <div className="rocessor_listright">
                    <h4>Lori Nielsen</h4>
                    <div className="rating">
                      <img src="assets/images/processor/rating.png" /> (4.5/10)
                    </div>
                    <div className="submit_filearea">
                      <a href="javascript:void(0);" className="submit_file">
                        Submit a File
                      </a>
                      <a href="javascript:void(0);" className="favorite_icon">
                        favorite
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div className="processor_listtop">
                  <div className="hour_ago">7 hours ago</div>
                  <div className="like_dislike">
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/like.svg" />
                    </a>
                    <span className="like_txt">30</span>
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/dislike.svg" />
                    </a>
                    <span className="dislike_txt">0</span>
                  </div>
                </div>
                <div className="processor_lisbottom">
                  <div className="rocessor_listimgctrl">
                    <div className="rocessor_listimg">
                      <img src="assets/images/processor/image_11.jpg" />
                      <span className="offline_circel"></span>
                    </div>
                  </div>
                  <div className="rocessor_listright">
                    <h4>Ashley Rooker</h4>
                    <div className="rating">
                      <img src="assets/images/processor/rating.png" /> (4.5/10)
                    </div>
                    <div className="submit_filearea">
                      <a href="javascript:void(0);" className="submit_file">
                        Submit a File
                      </a>
                      <a href="javascript:void(0);" className="favorite_icon">
                        favorite
                      </a>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div className="processor_listtop">
                  <div className="hour_ago">4 hours ago</div>
                  <div className="like_dislike">
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/like.svg" />
                    </a>
                    <span className="like_txt">30</span>
                    <a href="javascript:void(0);">
                      <img src="assets/images/processor/dislike.svg" />
                    </a>
                    <span className="dislike_txt">0</span>
                  </div>
                </div>
                <div className="processor_lisbottom">
                  <div className="rocessor_listimgctrl">
                    <div className="rocessor_listimg">
                      <img src="assets/images/processor/image_12.jpg" />
                      <span className="offline_circel"></span>
                    </div>
                  </div>
                  <div className="rocessor_listright">
                    <h4>Stephanie Selleroli</h4>
                    <div className="rating">
                      <img src="assets/images/processor/rating.png" /> (4.5/10)
                    </div>
                    <div className="submit_filearea">
                      <a href="javascript:void(0);" className="submit_file">
                        Submit a File
                      </a>
                      <a href="javascript:void(0);" className="favorite_icon">
                        favorite
                      </a>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>

       
      </div>
    </Layout>
  );
};

export default ProfileDetails;
